import { Model, RailsFormat } from "./model"
import { DiscountType } from "./discount-type";

export class Discount extends Model {

  constructor(
    public id?: number,
    public discountTypeId?: number,
    public contactId?: number,
    public description: string = null,
    public startDate: Date = null,
    public endDate: Date = null,
    public fixedAmount: number = null,

    public discountType: DiscountType = null,

    public isMenuOpen: boolean = false,

    public createdAt: Date = null,
    public updatedAt: Date = null,
  ) { super() }

  static clone(obj: any) {
    const o = new this()

    if (obj.id) { o.id = obj.id }
    if (obj.discountTypeId) { o.discountTypeId = obj.discountTypeId }
    if (obj.contactId) { o.contactId = obj.contactId }

    if (obj.description) { o.description = obj.description }
    if (obj.startDate) { o.startDate = new Date(obj.startDate) }
    if (obj.endDate) { o.endDate = new Date(obj.endDate) }
    if (obj.fixedAmount != undefined) { o.fixedAmount = obj.fixedAmount }

    if (obj.discountType) { o.discountType = DiscountType.clone(obj.discountType) }

    if (obj.createdAt) { o.createdAt = new Date(obj.createdAt) }
    if (obj.updatedAt) { o.updatedAt = new Date(obj.updatedAt) }

    return o
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/discount.ts